import {AddOn} from "@softline/application";
import { Signal } from '@angular/core';
import { Beleg } from '../types/beleg';
import { Belegart } from '../types/belegart';

export interface GesamtabfrageListAddOnParams {
  belegart: Signal<Belegart | null>;
  selected: Signal<Beleg[]>;
}

export abstract class GesamtabfrageListAddOn extends AddOn<GesamtabfrageListAddOnParams> {}
